// „POSLEDNJE IZMENE UNEO" i „DATUM POSLEDNJE IZMENE" formulara rizika (PR-10).
// Isto pravilo i format kao tabela Istorija procene rizika: ime i prezime
// zaposlenog, inače imejl; za deaktiviran nalog originalni imejl.
export const lastUpdatedByName = (formular) => {
  const user = formular?.lastUpdatedBy;
  if (!user) return "";
  const emp = user.employee;
  const name = `${emp?.first_name || ""} ${emp?.last_name || ""}`.trim();
  return name || user.original_email || user.email || "";
};

export const lastUpdatedAt = (formular) => {
  if (!formular?.last_updated) return "";
  const d = new Date(formular.last_updated);
  if (isNaN(d.getTime())) return "";
  return `${d.toLocaleDateString("sr-RS")} ${d.toLocaleTimeString("sr-RS", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};
